import { useEffect, useState } from "react";
import "./App.css";
import { Spinner } from "./atoms/spinner";
import { icon } from "./functions/icons";
import { GridLayout, HorizontalLayout, VerticalLayout } from "./components/layout";
import { StandardButton } from "./atoms/buttons";
import { ReviewFactory } from "./factory/reviewFactory";
import { ScoreOverview } from "./components/ScoreOverview";
import { getAPI, ip } from "./api/api";
import PreventPullToRefresh from "./components/stopRefresh";

export default function EmbedResult() {
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [exercises, setExercises] = useState([]);
  const [elearningInformation, setElearningInformation] = useState({});
  const [scoreResult, setScoreResult] = useState({})
  const embedIdMatch = window.location.href.match(/\/embed\/results\/([^\/?#]+)/);
  const id = embedIdMatch ? embedIdMatch[1] : null;

  useEffect(() => {
    loadScore()
    loadOverview();
  }, []);


  const loadScore = async () => {
    const score = await getAPI(`api/embed/results/${id}/score`)
    setScoreResult(score.data)
  }
  const loadOverview = async () => {
    if (!id) {
      setErrorMessage("Ongeldige of ontbrekende resultatenlink.");
      setLoading(false);
      return;
    }
    try {
      const res = await fetch(`${ip}/api/embed/results/${id}/overview`);
      const json = await res.json();
      const rows = json?.data || [];
      if (!Array.isArray(rows) || rows.length === 0) {
        setErrorMessage("Er is nog geen overzicht beschikbaar voor deze resultaten.");
      } else {
        setErrorMessage("");
        setExercises(rows);
        
        const courseId = rows?.[0]?.id_course;
        if (courseId) {
          await loadCourseInformation(courseId);
        }
      }
    } catch (e) {
      setErrorMessage("Oeps, er ging iets fout bij het inladen van jouw resultaten.");
    } finally {
      setLoading(false);
    }
  };

  const loadCourseInformation = async (courseId) => {
    try {
      const res = await fetch(`${ip}/api/courses/${courseId}`);
      const json = await res.json();
      const row = Array.isArray(json?.data) ? json.data[0] : null;
      if (row) {
        setElearningInformation(row);
      }
    } catch (e) {}
  };

  const calculateScoreData = (list) => {
    let total_questions = 0;
    let questions_passed = 0;
    list.forEach((ex) => {
      if (Array.isArray(ex.assessments_answer_content)) {
        total_questions++;
        const correct = ex.assessments_answer_content.find((ans) => ans.quiz_correct_answer === true);
        const chosenCorrect = correct && correct.chosen === true;
        if (chosenCorrect) questions_passed++;
      }
    });
    const isPassed = total_questions > 0 && questions_passed / total_questions > 0.55;
    return {
      total_questions,
      questions_passed,
      time_limit: "30 min",
      completed_in_time: true,
      skills_learned: isPassed && questions_passed ? questions_passed : "0",
      user_level: isPassed ? "expert" : "beginner",
      is_passed: isPassed,
    };
  };

  if (loading) {
    return (
      <VerticalLayout className="center-all complete-height">
        <Spinner color="grey-100" size="4rem" />
      </VerticalLayout>
    );
  }

  if (errorMessage) {
    return <EmbedError iconType="alert-triangle" errorTitle="Onbekende fout" message={errorMessage} />;
  }

  return (
    
    <div style={{ background: "var(--grey-50)", height: "100vh" }}>
      <div style={{ backgroundImage: `url('${elearningInformation?.image_url || ''}')` }} className="topbar-embed-bg">
        <div className="topbar-embed">
          {elearningInformation?.title}
          <br />
          <span style={{ fontWeight: "400" }} className="bottom-text-subtitle" >
            {elearningInformation?.description}
          </span>
        </div>
      </div>
      <div className="container" style={{ marginTop: "2rem", height: "calc(100dvh - 12rem)", overflowY: "auto" }}>
        <ScoreOverview data={scoreResult} compact={true} />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "var(--grey-600)", margin: "0.25rem 0 0.75rem 0" }}>
        </div>
        {exercises.map((exercise, index) => (
          <div key={index}>
            <ReviewFactory exercise={exercise} />
          </div>
        ))}
      </div>
    </div>
    
  );
}

function EmbedError({ iconType, errorTitle, message }) {
  return (
    <>
      <VerticalLayout className="center-all complete-height embed-error-box">
        <span className="small-standard-margin" style={{ color: "var(--grey-500)" }}>
          {icon(iconType, 96)}
        </span>
        <span
          style={{ color: "var(--grey-300)", textAlign: "center", fontSize: "1.5rem", fontWeight: 600, margin: "0.5rem 0px" }}
        >
          {errorTitle}
        </span>
        <br />
        {message && (
          <span style={{ color: "var(--grey-500)", textAlign: "center", margin: "0px 2rem", fontSize: "14px" }}>{message}</span>
        )}
      </VerticalLayout>
    </>
  );
}
